import React from 'react'
import { Typography } from '@material-ui/core'
import { StatusEtapaEnum } from 'src/api/pagamento'

interface StatusEtapaProps {
  status: StatusEtapaEnum
  style?: React.CSSProperties
}

const StatusEtapa: React.FC<StatusEtapaProps> = ({ status, style }) => {
  const getStatusColor = () => {
    if (status === StatusEtapaEnum.Pago) return 'rgb(21 145 62)'
    if (status === StatusEtapaEnum.Pendente) return '#ca5f21'
    if (status === StatusEtapaEnum.EmAndamento) return '#ca5f21'
    return '#666'
  }

  const getStatusBorderColor = () => {
    if (status === StatusEtapaEnum.Pago) return 'rgb(21 145 62)'
    if (status === StatusEtapaEnum.Pendente) return '#ca5f21'
    if (status === StatusEtapaEnum.EmAndamento) return '#ca5f21'
    return '#ddd'
  }

  const getStatusLabel = () => {
    return status
    if (status === StatusEtapaEnum.Pago) return 'Completo'
    if (status === StatusEtapaEnum.EmAndamento) return 'Em andamento'
    return 'Pendente'
  }

  function getStatusBackgroundColor() {
    if (status === StatusEtapaEnum.Pago) return '#dcf8e5'
    if (status === StatusEtapaEnum.Pendente) return 'rgb(243 162 62 / 14%)'
    if (status === StatusEtapaEnum.EmAndamento) return 'rgb(243 162 62 / 14%)'
    return '#f3f4f6'
  }

  return (
    <Typography
      variant="body2"
      style={{
        color: getStatusColor(),
        backgroundColor: getStatusBackgroundColor(),
        border: `1px solid ${getStatusBorderColor()}`,
        borderRadius: 4,
        fontWeight: 600,
        padding: '2px 8px',
        display: 'inline-block',
        ...style
      }}
    >
      {getStatusLabel()}
    </Typography>
  )
}

export default StatusEtapa
